import { Icon, TextEllipsis } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Tab } from '@mui/material';
import { memo, SyntheticEvent } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { BuyingTeamTabsProps as Props } from './types';

export const BuyingTeamTabs = memo(({ className, onChange, items }: Props) => {
  const handleChange = (event: SyntheticEvent, v: string) => {
    onChange(v);
  };

  return (
    <Styled.Wrapper
      className={classnames('BuyingTeamTabs', className)}
      sx={SX.root}
      onChange={handleChange}
    >
      {items?.map((x) => (
        <Tab
          key={x.index}
          icon={<Icon size={14} name={x.icon ?? 'business'} />}
          iconPosition="start"
          value={x.index}
          label={
            <TextEllipsis w="80px" value={x.label} sx={{ fontSize: '12px' }} />
          }
          sx={{ alignItems: 'center', marginRight: '16px!important' }}
        />
      ))}
    </Styled.Wrapper>
  );
});

BuyingTeamTabs.displayName = 'BuyingTeamTabs';
